export default __webpack_public_path__ + "static/media/cotton.8dda7e5b.png";